import { httpClient } from '@/lib/http-client'
import type { PermissionConfig } from '@/stores/permission-store'

export const apiGetMenu = (data: { studio_id: number }) =>
  httpClient.post<ApiResponse<PermissionConfig>>('account/user_menu', data)

export const apiCreateMenu = (data: M.IMenuItem) =>
  httpClient.post<ApiResponse<null>>('/backend/menu_add', data)

export const apiUpdateMenu = (data: M.IMenuItem) =>
  httpClient.post<ApiResponse<null>>('/backend/menu_update', data)

export const apiDelMenu = (data: M.IMenuItem) =>
  httpClient.post<ApiResponse<null>>('/backend/menu_delete', data)
